import { combineReducers } from 'redux';

import { commonReducer } from './common';
import { conversationDataRReducer } from './conversationDataR';
import { conversationNewReducer } from './conversationNew';
import { dashboardReducer } from './dashboard';
import { deploymentsReducer } from './deployments';
import { entitiesReducer } from './entities';
import { formReducer } from './form';

export const allReducers = combineReducers({
  common: commonReducer,
  conversationsDataR: conversationDataRReducer,
  conversationData: conversationNewReducer,
  dashboard: dashboardReducer,
  deployments: deploymentsReducer,
  entities: entitiesReducer,
  form: formReducer,
});
